import {
  LocationResponseDto,
  VariantCreateRequestApiV2Dto,
  VariantRequestDto,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';

const getLocationId = (
  newVariant: VariantRequestDto,
  mainLocation?: LocationResponseDto,
) =>
  newVariant.locationId
    ? newVariant.locationId
    : mainLocation
    ? mainLocation.id
    : '';

export const getCreateVariantPayload = (
  newVariant: VariantRequestDto,
  language: LanguagesType,
  mainLocation?: LocationResponseDto,
): VariantCreateRequestApiV2Dto => {
  const locationId = getLocationId(newVariant, mainLocation);
  return {
    price: newVariant.price ?? 0,
    inventory_levels: [
      { location_id: locationId, stock: newVariant.stock ?? 0 },
    ],
    attributes: newVariant.values.map((value) => ({
      ...value,
      default: value[language],
    })),
    weight: Number(newVariant.weight) || 0,
    width: Number(newVariant.width) || 0,
    height: Number(newVariant.height) || 0,
    depth: Number(newVariant.depth) || 0,
    ...(newVariant.sku && { sku: newVariant.sku }),
    ...(newVariant.barcode && { barcode: newVariant.barcode }),
    ...(newVariant.mpn && { mpn: newVariant.mpn }),
    ...(newVariant.age_group && { age_group: newVariant.age_group }),
    ...(newVariant.gender && { gender: newVariant.gender }),
  };
};
